import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const AlertTriangle = () => (
  <ImageIcon src={Images.AlertTriangle} alt="empty-data/" />
);

export default AlertTriangle;
